import React, { Suspense, useEffect, useMemo, useState } from 'react'
import HeaderForm from './headerTab/index'
import ErrorBoundary from './errorboundry'
import { getFormData, getDropdownValues } from '../api/getNLForm'
import get from 'lodash/get'
import { useDispatch, useSelector } from 'react-redux'
import { Tab, TabItem } from '../../commonComponents/formComponents/Tab'
import ShipmentInfoProvider from '../../context/shipmentInfo.js/index.js'
import { initializeDropDownValues } from '../actions/DropDownActions'
import { CustomLoader } from '../../commonComponents/formComponents/loader'
import { ErrorMessage } from '../../commonComponents/formComponents/ErrorMessage'
import { getJobWheels, isShipmentDisabled } from '../../util';
import { resetServerErrors } from "../../commonActions/serverErrorAction";
// import InvoiceContainer from '../../DMS_App/formSections/items'
import {
  InitializePartiesForm,
  initializeHeaderForm,
  clearForm,
  initializeItemForm,
} from '../actions'
import { exitInfoDisabledStatus,exitWarningDecStatus,exitInfoDisabledStatusAGS, emergencyProcVisibility } from './util'
import { SAVE_FORM_NL,DELETE_NL_ENTITY } from '../api/apiEvents'
import ActorProvider from './partiesTab/Actors/actorProvider'
import TranslateContextProvider from './TranslateContext'
import RubberBindingInfoProvider from '../../context/rubberBindingInfoProvider'
import { canUserFile } from '../../util';
import useIsMounted from '../../hooks/useIsMounted'
import {INIT_VALIDATION_ERRORS} from '../../commonActionTypes'
import validate from 'validate.js'
import { NL_fieldPatterns } from '../util/NL_fieldPatterns'
import { createValidationStructure } from '../../Helper'
import { validateInvoices } from '../util/itemsTabValidation'
import { initializeValueBuildUp } from '../../commonComponents/commonValueBuildUpTab/actions/ValueBuildUp'
import { clearForm as clearValueBuildUpForm} from '../../commonComponents/commonValueBuildUpTab/actions/ValueBuildUp'
const DisplayError = React.lazy(() => import('@commonComponents/displayError'))
const NotesTab = React.lazy(() => import('./NotesTab'))
const PartiesForm = React.lazy(() => import('./partiesTab/index'))
const ValueBuildUpTab =React.lazy(()=>import('./valueBuildUpTab/index'))
const InvoiceForm = React.lazy(() => import('./itemsTab/index'))
const ValidateError = React.lazy(() => import('../../commonComponents/validateError').then(module=>({default:module.ValidateError})))
const EmergencyDocument = React.lazy(() => import('@commonComponents/EmergencyDocument'))
import { Portal } from '../../commonComponents/portal'
import { useValidateCustomOfficesCode } from '../hooks/AGS/useValidateCustomOfficesCode'
import { MemoizeExchangeRates} from '../../commonComponents/ExchangeRates'

const NLForm = (props) => {
  let { isFormEnabled, serviceType,formType } = props
  const isDMS=formType!="AGS"
  
  const declarationStatus=React.useMemo(()=>{
     const jobWheels = getJobWheels(props.currentJobData)
     return jobWheels?.NL_CUSTOM_JOB_WHEEL?.value?.state?.replaceAll("STATE_","")
  },[props.currentJobData])

  const [loader, setLoader] = useState(false)
  const [error, setError] = useState(false)
  const dispatch = useDispatch()
  const isMounted = useIsMounted()
  const jobWheels = getJobWheels(props.currentJobData)
  let currentJobState = jobWheels ? jobWheels['ES_ENTRY_JOB_WHEEL']?.value?.state : ''
  let customJobState = jobWheels ? jobWheels['GB_CUSTOM_JOB_WHEEL']?.value?.state : ''
  let brokerHouseState = jobWheels ? jobWheels['SHIPMENT_BROKER_HOUSE_PROCESS']?.value?.state : ''
  const serverErrors = useSelector((state) => state.ServerErrorReducer.serverErrors)

  const userGuid = props.kxUserBasicInfo?.userGuid;
  const brokerGuid = props.currentJobData?.brokerGuid;
  const canFile = canUserFile(props.kxUserBasicInfo, props?.kxEngineUserInfo);
  const isFormDisabled = userGuid!==brokerGuid || !canFile || isShipmentDisabled(currentJobState, customJobState, false, brokerHouseState)
  
  const {validateCustomOffices}=useValidateCustomOfficesCode()
  useEffect(() => {
   
      const intilizeDropDownCalls = async () => {
        try {
          const response = await getDropdownValues(isDMS).catch((err) => console.log(err))
          response.data.eventMessage.expDeclarations =
            response.data.eventMessage.expDeclarations.map((item) => ({
              ...item,
              procedure: item.value == 'CO' ? ['B3', 'B4'] : ['B1', 'B2', 'C1'],
            }))
          response.data.eventMessage.impDeclarations =
            response.data.eventMessage.impDeclarations.map((item) => ({
              ...item,
              procedure: item.value == 'CO' ? ['H5'] : ['H1', 'H2', 'H3', 'H4', 'H6', 'I1'],
            }))
          response.data.eventMessage.incoTerms = response.data.eventMessage.incoTerms.map((item) =>
            ['FAS', 'FOB', 'CFR', 'CIF'].includes(item.value) ? { ...item, mot: ['1', '8'] } : item
          )
      
          dispatch(initializeDropDownValues(response.data.eventMessage))
        } catch (err) {}
      }
      intilizeDropDownCalls()
  
  }, [isDMS])
  useEffect(() => {
    const getData = async () => {
      setLoader(true)
      setError('')
      try {
        const response = await getFormData(props.shipId, serviceType)
        const { data: { eventMessage: { headerParties, header, invoiceHeader, invoices }}} = response
  
        window.shipmentId = props.shipId
        let headerErrors={}
        if(!isDMS && serviceType!='IM') { // for AGS Export only
          header.customsOffice=header?.customsOffice || []
          // addDefaultCUstomOffices start
          const list=["DEC","EXT"]
          list.forEach((type,index)=>{
            const currentIndex=header?.customsOffice.findIndex(c=>c.type==type)
            if(currentIndex==-1)
              header.customsOffice.push({id:Date.now()+index,type,office:"",hideDeleteBtn:true,isDisabled:true})
            else{
            header.customsOffice[currentIndex].hideDeleteBtn=true
            header.customsOffice[currentIndex].isDisabled=true
            }
          })
           // addDefaultCUstomOffices end
         
          headerErrors=validateCustomOffices(header.customsOffice)
        }
        
        dispatch(initializeHeaderForm(header))
        dispatch(InitializePartiesForm(headerParties))
        dispatch(initializeItemForm({ invoiceHeader, invoices }))
        dispatch(initializeValueBuildUp(window.shipmentId))
        dispatch(resetServerErrors())

        if(!isDMS){
          let validateHeaderErrors=validate(header,NL_fieldPatterns(isDMS)({isValueXXX:header?.transportation?.tradeTerms?.incoTerms,customsOffice:header?.customsOffice,mot:header?.transportation?.departureTransitMode?.mot}).header) || {}
          headerErrors = {...createValidationStructure(validateHeaderErrors),...headerErrors}      
          let validatePartiesErrors=validate(headerParties,NL_fieldPatterns(isDMS)()?.parties) || {}  
          const partiesErrors = createValidationStructure(validatePartiesErrors)

          let itemErrors = validateInvoices(invoices, NL_fieldPatterns(isDMS)()?.items) || {}
        
        dispatch({type:INIT_VALIDATION_ERRORS,payload:{header:headerErrors, parties:partiesErrors, items:itemErrors}})
      }
        setLoader(false)
      } catch (e) {
        console.log(e)
        setLoader(false)
        setError(e)
      }
    }
    getData()
    sessionStorage.removeItem('toggleInvoices')
    sessionStorage.removeItem('toggleLineItems')
    return () => {
      dispatch(clearForm())
      dispatch(clearValueBuildUpForm())
    }
  }, [props.shipId])
 
  const kxUserBasicInfo = get(props, 'kxUserBasicInfo', {})
  const isEmergencyProcVisible=useMemo(()=>emergencyProcVisibility(declarationStatus),[declarationStatus])
  const exitInfoStatus=useMemo(()=>({disabled:(declarationStatus==exitInfoDisabledStatus || declarationStatus==exitInfoDisabledStatusAGS),exitInfoCurrentStatus:exitWarningDecStatus(isDMS)[declarationStatus]}),[declarationStatus,isDMS])
  let content
  //debugger;
  if (error) content = <ErrorMessage>An Error Occured In Loading NL Form</ErrorMessage>
  else if (loader) content = <CustomLoader>Preparing Form</CustomLoader>
  else if (props.shipId && isMounted) {
    content = (
      <ErrorBoundary>
        <div style={{ marginTop: '5px' }} className='tabContainer C88'>
        <TranslateContextProvider translate={props.translate}>
          <ShipmentInfoProvider isDMS={isDMS} deleteEvent={DELETE_NL_ENTITY} saveEvent={SAVE_FORM_NL} declarationStatus={declarationStatus} exitInfoStatus={exitInfoStatus} serviceType={serviceType} isDisabled={isFormDisabled} currentJobState={currentJobState}>
          <RubberBindingInfoProvider rubberBindingInfo={props.rubberBindingInfo} >
            <ActorProvider>
            {
              isEmergencyProcVisible && <Portal targetElementId="emergencyContainer">
              <EmergencyDocument translate={props.translate} / >
            </Portal>
            }
             <Portal targetElementId="exchangeRatesContainer">
              <MemoizeExchangeRates translate={props.translate} />
            </Portal>
            <Suspense fallback={<div>Loading...</div>}>
            {
              serverErrors && <ValidateError serverErrors={serverErrors} />
            }
            
            <Tab className="euForm" translate={props.translate}>
              <TabItem title='Header'>
                <DisplayError tabName="header"/>
                <HeaderForm />
              </TabItem>
              <TabItem title='Parties'>
                <DisplayError tabName="parties"/>
                <PartiesForm  />
              </TabItem>
              <TabItem title='Value Build Up'>
                <ValueBuildUpTab {...props} />
              </TabItem>
              <TabItem title='Items'>
                <DisplayError tabName="items"/>
                        <InvoiceForm />
                        {/* <InvoiceContainer /> */}
              </TabItem>
              <TabItem title='Notes'>
                <NotesTab
                  kxUserBasicInfo={kxUserBasicInfo}
                  isFormEnabled={isFormEnabled}
                  shipId={props.shipId}
                  fullName={get(kxUserBasicInfo, 'fullName', '')}
                ></NotesTab>
              </TabItem>
            </Tab>
            </Suspense>
            </ActorProvider>
            </RubberBindingInfoProvider>
          </ShipmentInfoProvider>
          </TranslateContextProvider>
        </div>
        <div className='toast'></div>
      </ErrorBoundary>
    )
  }
  else{
    content = null;
  }
  return content
}
export default React.memo(NLForm)
